import {Product} from '@framework/types';
import http from '@framework/utils/http';
import {API_ENDPOINTS} from '@framework/utils/api-endpoints';
import {useQuery} from '@tanstack/react-query';

export const fetchProductBySlug = async (_slug: string) => {
  const {data} = await http.get(`${API_ENDPOINTS.PRODUCTS}/${_slug}`);
  return data.data;
};
export const useProductBySlugQuery = (slug: string) => {
  return useQuery<Product, Error>({
    queryKey: [API_ENDPOINTS.PRODUCTS, slug],
    queryFn: () => fetchProductBySlug(slug),
  });
};
